import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "src/components/ui/Card";
import LoginForm from "src/components/forms/LoginForm";

import { getFromStorage, setToStorage } from "src/utils/storage";
import storageKeys from "src/constants/storage";
import * as authActions from "src/redux/slices/authAdminSlice";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";

const LoginPage: React.FC = () => {
  const [apiError, setApiError] = useState("");

  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const { login } = useAppSelector((state) => state.authAdmin);

  useEffect(() => {
    const authAdminToken = getFromStorage(storageKeys.authAdminToken);
    if (authAdminToken) {
      navigate("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    if (login?.data?.token) {
      console.log("Login data:", login.data);
      // On successful login, redirect to admin dashboard
      setToStorage(storageKeys.authAdminToken, login.data.token);
      dispatch(authActions.getUserDetailsRequest());
      navigate("/admin/dashboard");
    } else if (login?.error) {
      setApiError(login.error);
    }
  }, [login, navigate]);

  const handleSubmit = (
    data:
      | {
          email: string;
          password: string;
        }
      | any
  ) => {
    // Dispatch login action
    dispatch(authActions.loginRequest(data));
  };

  return (
    <div className="min-h-screen flex bg-slate-950">
      {/* Left Branding Section */}
      <div className="hidden lg:flex w-1/2 text-white flex-col justify-between p-12 relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-sky-700">
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1 text-xs uppercase tracking-[0.25em] text-sky-200">
            Admin Console
          </div>
          <div className="mt-6 text-4xl font-semibold tracking-tight">
            Invyntra Control Room
          </div>
          <p className="mt-4 text-sm text-slate-200 max-w-md">
            Review tenant health, activate plans, and resolve escalations with
            full visibility across the platform.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3 text-xs text-slate-200">
            <div className="rounded-xl bg-white/10 p-3">
              Platform revenue insights
            </div>
            <div className="rounded-xl bg-white/10 p-3">
              Tenant lifecycle actions
            </div>
            <div className="rounded-xl bg-white/10 p-3">
              Risk & compliance alerts
            </div>
            <div className="rounded-xl bg-white/10 p-3">
              Support prioritization
            </div>
          </div>
        </div>
        {/* <div className="relative z-10 mt-10">
          <img
            src="/assets/admin-login-visual.svg"
            alt="Admin analytics dashboard"
            className="w-full max-w-md"
          />
        </div> */}
        <div className="absolute -top-20 -left-24 h-64 w-64 rounded-full bg-sky-500/20 blur-3xl" />
        <div className="absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-indigo-400/20 blur-3xl" />
      </div>

      {/* Right Login Form */}
      <div className="flex-1 flex items-center justify-center bg-slate-100 p-6">
        <div className="w-full max-w-md">
          <Card>
            <div className="text-lg font-semibold text-center">
              Sign in to Admin
            </div>
            <div className="text-sm text-gray-500 text-center mt-2 mb-4">
              Use your Invyntra internal credentials to continue.
            </div>

            {apiError && (
              <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-sm text-center">
                {apiError}
              </div>
            )}
            <LoginForm handleSubmit={handleSubmit} />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
